module.exports = __webpack_public_path__ + "static/img/008.e810bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/008.png
// module id = 7Zb5
// module chunks = 1